import React from 'react'
import styles from './styles/Devteam1.module.css'
import { FaInstagram, FaLinkedinIn } from "react-icons/fa"
import { FaGithub } from "react-icons/fa"
import { FaFacebook } from "react-icons/fa"
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import { useContext } from 'react';
import NotifContext from '../context/NotifContext'
import styleNotif from './styles/Feed.module.css'
import NotifContainer from '../components/Notifs/NotifContainer'
import Footers from '../components/Footer';

function Devteam()
{
  const { status, togglePlayPause } = useContext(NotifContext);
  console.log(status)
    return (
        <><div className={styles.meetteam}>
    <div className={status? styleNotif.active: styleNotif.notactive}>
      <NotifContainer />
    </div>
    <div className={styles.teamTitle}>
            <h2 data-text="MEET OUR TEAM">MEET OUR TEAM</h2>
            <div className={styles.line1}>Meet our Dedicated Team working tirelessly to reminisce about your college memories!</div>
        </div>
        


        
        <div className={styles.container5}>
  <div className="row">
      <div className="col-12 col-lg-12">
        <div className={styles.team}>
      <div className={`${styles.team__item} ${styles.oc1}`} >
        <div className={styles.team__text}>
          <div className={styles.team__title}>
          <p>Kartik Vaishnav </p>
            <span>SARC Overall Coordinator, 2025-26</span>
          </div>
          <div className={styles.team__social}>
                      <a href="https://www.linkedin.com/in/kartik-vaishnav-12a758251"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/kartik__vaishnav?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="><FaInstagram /></a>
          </div>
        </div>
        <div className={styles.textMobile}>
          <div className={styles.titleMobile}>
          <p>Kartik Vaishnav</p>
            <span>SARC Overall Coordinator, 2025-26</span>
          </div>
          <div className={styles.socialMobile}>
                      <a href="https://www.linkedin.com/in/kartik-vaishnav-12a758251"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/kartik__vaishnav?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="><FaInstagram /></a>
          </div>
        </div>
      </div>
    </div>
    </div>
    {/* <div className="col-12 col-lg-6">
        <div className={styles.team}>
      <div className={`${styles.team__item} ${styles.oc2}`} >
        <div className={styles.team__text}>
          <div className={styles.team__title}>
          <p>Aastha Patel</p>
            <span>SARC Overall Co-ordinator, 2024-25</span>
          </div>
          <div className={styles.team__social}>
                      <a href="https://www.linkedin.com/in/aastha-patel-048609207"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/12_khushii/"><FaInstagram /></a>
          </div>
        </div>
        <div className={styles.textMobile}>
          <div className={styles.titleMobile}>
          <p>Aastha Patel</p>
            <span>SARC Overall Co-ordinator, 2024-25
            </span>
          </div>
          <div className={styles.socialMobile}>
                      <a href="https://www.linkedin.com/in/aastha-patel-048609207"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/12_khushii/"><FaInstagram /></a>
          </div>
        </div>
      </div>
    </div>
    </div> */}
    </div>
    </div>
        
        <div className={styles.team_name}>
          <span className={styles.team_name_text}>
            WEB TEAM
          </span></div>

        <div className={styles.container1}>
  <div className="row">
  <div className="col-12 col-lg-6">
        <div className={styles.team}>
      <div className={`${styles.team__item} ${styles.akash}`} >
        <div className={styles.team__text}>
          <div className={styles.team__title}>
            <p>Arush Srivastav</p>
            <span>SARC Web CTM 2025-26</span>
          </div>
          <div className={styles.team__social}>
                      <a href="https://github.com/arushsri"><FaGithub /></a>
                      <a href="https://www.linkedin.com/in/arush-narayan-srivastav-001/"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/itss.arushhh?igsh=MWp1bzZrdmhybXNldw=="><FaInstagram /></a>
          </div>
        </div>
        <div className={styles.textMobile}>
          <div className={styles.titleMobile}>
            <p>Arush Srivastav</p>
            <span>SARC Web CTM 2025-26</span>
          </div>
          <div className={styles.socialMobile}>
                      <a href="https://github.com/arushsri"><FaGithub /></a>
                      <a href="https://www.linkedin.com/in/arush-narayan-srivastav-001/"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/itss.arushhh?igsh=MWp1bzZrdmhybXNldw=="><FaInstagram /></a>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div className="col-12 col-lg-6">
        <div className={styles.team}>
      <div className={`${styles.team__item} ${styles.pranita}`} >
        <div className={styles.team__text}>
          <div className={styles.team__title}>
            <p>Khushi Yadav</p>
            <span>SARC Web CTM 2025-26</span>
          </div>
          <div className={styles.team__social}>
                      <a href="https://github.com/KhushiYadav18"><FaGithub /></a>
                      <a href="https://www.linkedin.com/in/khushi-yadav-0275b6293?"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/yadavk_18/profilecard/?igsh=MTRoN3lodjJ1ODh1aQ=="><FaInstagram /></a>
          </div>
        </div>
        <div className={styles.textMobile}>
          <div className={styles.titleMobile}>
            <p>Khushi Yadav</p>
            <span>SARC Web CTM 2025-26</span>
          </div>
          <div className={styles.socialMobile}>
                      <a href="https://github.com/KhushiYadav18"><FaGithub /></a>
                      <a href="https://www.linkedin.com/in/khushi-yadav-0275b6293?"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/yadavk_18/profilecard/?igsh=MTRoN3lodjJ1ODh1aQ=="><FaInstagram /></a>
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
    </div>

  
    <div className={styles.container5}>
  <div className="row">
      <div className="col-12 col-lg-6">
        <div className={styles.team}>
        <div className={`${styles.team__item} ${styles.akshat}`} >
        <div className={styles.team__text}>
          <div className={styles.team__title}>
            <p>Indrani Sahu</p>
            <span>SARC Web CTM 2026-27</span>
          </div>
          <div className={styles.team__social}>
                      <a href="https://github.com/IndraniSahu423"><FaGithub /></a>
                      <a href="https://www.linkedin.com/in/indrani-sahu-358049343?utm_source=share_via&utm_content=profile&utm_medium=member_android"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/infinity.423?igsh=d3d1djI0NzYxdzEy"><FaInstagram /></a>
          </div>
        </div>
        <div className={styles.textMobile}>
          <div className={styles.titleMobile}>
            <p>Indrani Sahu</p>
            <span>SARC Web CTM 2026-27</span>
          </div>
          <div className={styles.socialMobile}>
                      <a href="https://github.com/IndraniSahu423"><FaGithub /></a>
                      <a href="https://www.linkedin.com/in/indrani-sahu-358049343?utm_source=share_via&utm_content=profile&utm_medium=member_android"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/infinity.423?igsh=d3d1djI0NzYxdzEy"><FaInstagram /></a>
          </div>
        </div>
      </div>
    </div>
    </div>
    
    {/* <div className="col-12 col-lg-6">
        <div className={styles.team}>
      <div className={`${styles.team__item} ${styles.ashwani}`} >
        <div className={styles.team__text}>
          <div className={styles.team__title}>
            <p>Khushi Yadav</p>
            <span>SARC Web CTM 2025-26</span>
          </div>
          <div className={styles.team__social}>
                      <a href="https://github.com/KhushiYadav18"><FaGithub /></a>
                      <a href="https://www.linkedin.com/in/khushi-yadav-0275b6293?"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/yadavk_18/profilecard/?igsh=MTRoN3lodjJ1ODh1aQ=="><FaInstagram /></a>
          </div>
        </div>
        <div className={styles.textMobile}>
          <div className={styles.titleMobile}>
            <p>Khushi Yadav</p>
            <span>SARC Web CTM 2025-26</span>
          </div>
          <div className={styles.socialMobile}>
                      <a href="https://github.com/KhushiYadav18"><FaGithub /></a>
                      <a href="https://www.linkedin.com/in/khushi-yadav-0275b6293?"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/yadavk_18/profilecard/?igsh=MTRoN3lodjJ1ODh1aQ=="><FaInstagram /></a>
          </div>
        </div>
      </div>
    </div>
    </div> */}
    </div>
    </div>



    {/* <div className={styles.container2}>
  <div className="row">
      <div className="col-12 col-lg-4">
        <div className={styles.team}>
      <div className={`${styles.team__item} ${styles.akshat}`} >
        <div className={styles.team__text}>
          <div className={styles.team__title}>
            <p>Akshat Jain</p>
            <span>SARC Web CTM 2024-25</span>
          </div>
          <div className={styles.team__social}>
                      <a href="https://github.com/akshat1423"><FaGithub /></a>
                      <a href="https://www.linkedin.com/in/akshat-jain-069822250/"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/akshatj._/"><FaInstagram /></a>
          </div>
        </div>
        <div className={styles.textMobile}>
          <div className={styles.titleMobile}>
            <p>Akshat Jain</p>
            <span>SARC Web CTM 2024-25</span>
          </div>
          <div className={styles.socialMobile}>
                      <a href="https://github.com/akshat1423"><FaGithub /></a>
                      <a href="https://www.linkedin.com/in/akshat-jain-069822250/"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/akshatj._/"><FaInstagram /></a>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div className="col-12 col-lg-4">
        <div className={styles.team}>
      <div className={`${styles.team__item} ${styles.pranita}`} >
        <div className={styles.team__text}>
          <div className={styles.team__title}>
            <p>Pranita Randive</p>
            <span>SARC Web CTM 2024-25</span>
          </div>
          <div className={styles.team__social}>
                      <a href="https://github.com/PranitaR12"><FaGithub /></a>
                      <a href="https://www.linkedin.com/in/pranita-randive-001581244"><FaLinkedinIn /></a>
                      <a href="https://instagram.com/pranitarandive12?igshid=ZGUzMzM3NWJiOQ=="><FaInstagram /></a>
          </div>
        </div>
        <div className={styles.textMobile}>
          <div className={styles.titleMobile}>
            <p>Pranita Randive</p>
            <span>SARC Web CTM 2024-25</span>
          </div>
          <div className={styles.socialMobile}>
                      <a href="https://github.com/PranitaR12"><FaGithub /></a>
                      <a href="https://www.linkedin.com/in/pranita-randive-001581244"><FaLinkedinIn /></a>
                      <a href="https://instagram.com/pranitarandive12?igshid=ZGUzMzM3NWJiOQ=="><FaInstagram /></a>
          </div>
        </div>
      </div>
    </div>
    </div> */}
    {/* <div className="col-12 col-lg-4">
        <div className={styles.team}>
      <div className={`${styles.team__item} ${styles.shivesh}`} >
        <div className={styles.team__text}>
          <div className={styles.team__title}>
            <p>Shivesh Gupta</p>
            <span>SARC Web Co-ordinator 2022-23</span>
          </div>
          <div className={styles.team__social}>
                      <a href="https://github.com/shiveshcodes"><FaGithub /></a>
                      <a href="https://www.linkedin.com/in/shivesh-gupta-iitb"><FaLinkedinIn /></a>
                      <a href="https://instagram.com/sagacious_shiv?igshid=NTc4MTIwNjQ2YQ=="><FaInstagram /></a>
          </div>
        </div>
        <div className={styles.textMobile}>
          <div className={styles.titleMobile}>
            <p>Shivesh Gupta</p>
            <span>SARC Web Co-ordinator 2022-23</span>
          </div>
          <div className={styles.socialMobile}>
                      <a href="https://github.com/shiveshcodes"><FaGithub /></a>
                      <a href="https://www.linkedin.com/in/shivesh-gupta-iitb"><FaLinkedinIn /></a>
                      <a href="https://instagram.com/sagacious_shiv?igshid=NTc4MTIwNjQ2YQ=="><FaInstagram /></a>
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
    </div>

        
        <div className={styles.container3}>
          <div className="row">
            <div className="col-12 col-lg-3">
              <div className={styles.team}>
                <div className={`${styles.team__item} ${styles.nilabha}`} >
                  <div className={styles.team__text}>
                    <div className={styles.team__title}>
                      <p>Nilabha Saha</p>
                      <span>SARC Web Co-ordinator 2022-23</span>
                    </div>
                    <div className={styles.team__social}>
                      <a href=""><FaGithub /></a>
                      <a href="https://www.linkedin.com/in/nilabha-saha-056b8a225"><FaLinkedinIn /></a>
                      <a href="https://instagram.com/nilabhasaha13?igshid=NTc4MTIwNjQ2YQ=="><FaInstagram /></a>
                    </div>
                  </div>
                  <div className={styles.textMobile}>
                    <div className={styles.titleMobile}>
                      <p>Nilabha Saha</p>
                      <span>SARC Web Co-ordinator 2022-23</span>
                    </div>
                    <div className={styles.socialMobile}>
                      <a href=""><FaGithub /></a>
                      <a href="https://www.linkedin.com/in/nilabha-saha-056b8a225"><FaLinkedinIn /></a>
                      <a href="https://instagram.com/nilabhasaha13?igshid=NTc4MTIwNjQ2YQ=="><FaInstagram /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-3">
              <div className={styles.team}>
                <div className={`${styles.team__item} ${styles.darshan}`} >
                  <div className={styles.team__text}>
                    <div className={styles.team__title}>
                      <p>Darshan Makwana</p>
                      <span>SARC Web Co-ordinator 2022-23</span>
                    </div>
                    <div className={styles.team__social}>
                      <a href=""><FaGithub /></a>
                      <a href="http://www.linkedin.com/in/darshan-makwana-282480228"><FaLinkedinIn /></a>
                      <a href="https://instagram.com/darshanmakwana434?igshid=NTc4MTIwNjQ2YQ=="><FaInstagram /></a>
                    </div>
                  </div>
                  <div className={styles.textMobile}>
                    <div className={styles.titleMobile}>
                      <p>Darshan Makwana</p>
                      <span>SARC Web Co-ordinator 2022-23</span>
                    </div>
                    <div className={styles.socialMobile}>
                      <a href=""><FaGithub /></a>
                      <a href="http://www.linkedin.com/in/darshan-makwana-282480228"><FaLinkedinIn /></a>
                      <a href="https://instagram.com/darshanmakwana434?igshid=NTc4MTIwNjQ2YQ=="><FaInstagram /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-3">
              <div className={styles.team}>
                <div className={`${styles.team__item} ${styles.ansh}`} >
                  <div className={styles.team__text}>
                    <div className={styles.team__title}>
                      <p>Ansh Preet</p>
                      <span>SARC Web Co-ordinator 2022-23</span>
                    </div>
                    <div className={styles.team__social}>
                      <a href=""><FaGithub /></a>
                      <a href="https://www.linkedin.com/in/ansh-preet-851077236"><FaLinkedinIn /></a>
                      <a href="https://instagram.com/anshpreet022?igshid=NTc4MTIwNjQ2YQ=="><FaInstagram /></a>
                    </div>
                  </div>
                  <div className={styles.textMobile}>
                    <div className={styles.titleMobile}>
                      <p>Ansh Preet</p>
                      <span>SARC Web Co-ordinator 2022-23</span>
                    </div>
                    <div className={styles.socialMobile}>
                      <a href=""><FaGithub /></a>
                      <a href="https://www.linkedin.com/in/ansh-preet-851077236"><FaLinkedinIn /></a>
                      <a href="https://instagram.com/anshpreet022?igshid=NTc4MTIwNjQ2YQ=="><FaInstagram /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-3">
              <div className={styles.team}>
                <div className={`${styles.team__item} ${styles.shreetosh}`} >
                  <div className={styles.team__text}>
                    <div className={styles.team__title}>
                      <p>Shreetosh Shelar</p>
                      <span>SARC Web Co-ordinator 2022-23</span>
                    </div>
                    <div className={styles.team__social}>
                      <a href=""><FaGithub /></a>
                      <a href="https://www.linkedin.com/in/shreetosh-shelar-61a036242"><FaLinkedinIn /></a>
                      <a href="https://instagram.com/shree03_shelar?igshid=NTc4MTIwNjQ2YQ=="><FaInstagram /></a>
                    </div>
                  </div>
                  <div className={styles.textMobile}>
                    <div className={styles.titleMobile}>
                      <p>Shreetosh Shelar</p>
                      <span>SARC Web Co-ordinator 2022-23</span>
                    </div>
                    <div className={styles.socialMobile}>
                      <a href=""><FaGithub /></a>
                      <a href="https://www.linkedin.com/in/shreetosh-shelar-61a036242"><FaLinkedinIn /></a>
                      <a href="https://instagram.com/shree03_shelar?igshid=NTc4MTIwNjQ2YQ=="><FaInstagram /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* Mpr design hi comment krdo abhi */}
        {/*  */}
        <div className={styles.team_name}>
          <span className={styles.team_name_text}>
            DESIGN TEAM
          </span></div>
        <div className={styles.container1}>
          <div className="row">
            <div className="col-12 col-lg-6">
              <div className={styles.team}>
                <div className={`${styles.team__item} ${styles.himanshu}`} >
                  <div className={styles.team__text}>
                    <div className={styles.team__title}>
                      <p>Sarthak Hase</p>
                      <span>SARC Design CTM 2025-26</span>
                    </div>
                    <div className={styles.team__social}>
                      
                      <a href="https://www.linkedin.com/in/sarthak-hase-9503aa241/"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/sarthak_hase/"><FaInstagram /></a>
                    </div>
                  </div>
                  <div className={styles.textMobile}>
                    <div className={styles.titleMobile}>
                    <p>Sarthak Hase</p>
                      <span>SARC Design CTM 2025-26</span>
                    </div>
                    <div className={styles.team__social}>
                      
                      <a href="https://www.linkedin.com/in/sarthak-hase-9503aa241/"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/sarthak_hase/"><FaInstagram /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <div className={styles.team}>
                <div className={`${styles.team__item} ${styles.jay}`} >
                  <div className={styles.team__text}>
                    <div className={styles.team__title}>
                    <p>Gayatri Sahu</p>
                      <span>SARC Design CTM 2025-26</span>
                    </div>
                    <div className={styles.team__social}>
                      
                      <a href="www.linkedin.com/in/gayatri-sahu-948310295"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/_gayu_02__?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="><FaInstagram /></a>
                    </div>
                  </div>
                  <div className={styles.textMobile}>
                    <div className={styles.titleMobile}>
                    <p>Gayatri Sahu</p>
                      <span>SARC Design CTM 2025-26</span>
                    </div>
                    <div className={styles.team__social}>
                      
                      <a href="www.linkedin.com/in/gayatri-sahu-948310295"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/_gayu_02__?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="><FaInstagram /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.team_name}>
          <span className={styles.team_name_text}>
            MEDIA & PR TEAM
          </span></div>
        <div className={styles.container1}>
          <div className="row">
            <div className="col-12 col-lg-6">
              <div className={styles.team}>
                <div className={`${styles.team__item} ${styles.priyanshi}`} >
                  <div className={styles.team__text}>
                    <div className={styles.team__title}>
                      <p>Poorvi Bansal</p>
                      <span>SARC Media & PR CTM 2025-26</span>
                    </div>
                    <div className={styles.team__social}>
                      
                      <a href="https://www.linkedin.com/in/poorvi-bansal-1615b62a4?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/poorvib_272?igsh=bXQwZGdwd3J5N2M="><FaInstagram /></a>
                    </div>
                  </div>
                  <div className={styles.textMobile}>
                    <div className={styles.titleMobile}>
                    <p>Poorvi Bansal</p>
                      <span>SARC Media & PR CTM 2025-26</span>
                    </div>
                    <div className={styles.team__social}>
                      
                      <a href="https://www.linkedin.com/in/poorvi-bansal-1615b62a4?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/poorvib_272?igsh=bXQwZGdwd3J5N2M="><FaInstagram /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <div className={styles.team}>
                <div className={`${styles.team__item} ${styles.vaibhavi}`} >
                  <div className={styles.team__text}>
                    <div className={styles.team__title}>
                    <p>Rutuja Dhabarde</p>
                      <span>SARC Media & PR CTM 2025-26</span>
                    </div>
                    <div className={styles.team__social}>
                      
                      <a href="https://www.linkedin.com/in/rutuja-d?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/rutuja.dhabarde"><FaInstagram /></a>
                    </div>
                  </div>
                  <div className={styles.textMobile}>
                    <div className={styles.titleMobile}>
                    <p>Rutuja Dhabarder</p>
                      <span>SARC Media & PR CTM 2025-26</span>
                    </div>
                    <div className={styles.team__social}>
                      
                      <a href="https://www.linkedin.com/in/rutuja-d?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/rutuja.dhabarde"><FaInstagram /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        {/* <div className={styles.container4}>
          <div className="row">
            <div className="col-12 col-lg-2">
              <div className={styles.team}>
                <div className={`${styles.team__item} ${styles.siddhant}`} >
                  <div className={styles.team__text}>
                    <div className={styles.team__title}>
                      <p>Siddhant Chourasia</p>
                      <span>SARC Design Co-ordinator 2022-23</span>
                    </div>
                    <div className={styles.team__social}>
                     
                      <a href="https://www.linkedin.com/in/siddhant-chourasia-851647223"><FaLinkedinIn /></a>
                      <a href="https://instagram.com/siddhant3.6?igshid=YmMyMTA2M2Y="><FaInstagram /></a>
                    </div>
                  </div>
                  <div className={styles.textMobile}>
                    <div className={styles.titleMobile}>
                      <p>Siddhant Chourasia</p>
                      <span>SARC Design Co-ordinator 2022-23</span>
                    </div>
                    <div className={styles.socialMobile}>
                      
                      <a href="https://www.linkedin.com/in/siddhant-chourasia-851647223"><FaLinkedinIn /></a>
                      <a href="https://instagram.com/siddhant3.6?igshid=YmMyMTA2M2Y="><FaInstagram /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-2">
              <div className={styles.team}>
                <div className={`${styles.team__item} ${styles.himanshu}`} >
                  <div className={styles.team__text}>
                    <div className={styles.team__title}>
                      <p>Akshita Choudhary</p>
                      <span>SARC Design CTM 2024-25</span>
                    </div>
                    <div className={styles.team__social}>
                      
                      <a href="akshita-choudhary-851319253?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><FaLinkedinIn /></a>
                      <a href="http://instagram.com/_himansh45"><FaInstagram /></a>
                    </div>
                  </div>
                  <div className={styles.textMobile}>
                    <div className={styles.titleMobile}>
                      <p>Akshita Choudhary</p>
                      <span>SARC Design CTM 2024-25</span>
                    </div>
                    <div className={styles.socialMobile}>
                      
                      <a href="akshita-choudhary-851319253?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><FaLinkedinIn /></a>
                      <a href="http://instagram.com/_himansh45"><FaInstagram /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-2">
              <div className={styles.team}>
                <div className={`${styles.team__item} ${styles.jay}`} >
                  <div className={styles.team__text}>
                    <div className={styles.team__title}>
                      <p>Jinisha Sabadra</p>
                      <span>SARC Design CTM 2024-25</span>
                    </div>
                    <div className={styles.team__social}>
                      
                      <a href="jinisha-sabadra-37949a263"><FaLinkedinIn /></a>
                      <a href="jinisha_2784?igsh=eTR2YjJveDRvM29p"><FaInstagram /></a>
                    </div>
                  </div>
                  <div className={styles.textMobile}>
                    <div className={styles.titleMobile}>
                      <p>Jinisha Sabadra</p>
                      <span>SARC Design CTM 2024-25</span>
                    </div>
                    <div className={styles.socialMobile}>
                      
                      <a href="jinisha-sabadra-37949a263"><FaLinkedinIn /></a>
                      <a href="jinisha_2784?igsh=eTR2YjJveDRvM29p"><FaInstagram /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-2">
              <div className={styles.team}>
                <div className={`${styles.team__item} ${styles.om}`} >
                  <div className={styles.team__text}>
                    <div className={styles.team__title}>
                      <p>Om Unhale</p>
                      <span>SARC Design Co-ordinator 2022-23</span>
                    </div>
                    <div className={styles.team__social}>
                     
                      <a href="https://www.linkedin.com/in/om-unhale-3360aa202"><FaLinkedinIn /></a>
                      <a href="https://instagram.com/om_unhale_123?igshid=NTc4MTIwNjQ2YQ=="><FaInstagram /></a>
                    </div>
                  </div>
                  <div className={styles.textMobile}>
                    <div className={styles.titleMobile}>
                      <p>Om Unhale</p>
                      <span>SARC Design Co-ordinator 2022-23</span>
                    </div>
                    <div className={styles.socialMobile}>
                    
                      <a href="https://www.linkedin.com/in/om-unhale-3360aa202"><FaLinkedinIn /></a>
                      <a href="https://instagram.com/om_unhale_123?igshid=NTc4MTIwNjQ2YQ=="><FaInstagram /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-2">
              <div className={styles.team}>
                <div className={`${styles.team__item} ${styles.dhruv}`} >
                  <div className={styles.team__text}>
                    <div className={styles.team__title}>
                      <p>Dhruv Patel</p>
                      <span>SARC Design Co-ordinator 2022-23</span>
                    </div>
                    <div className={styles.team__social}>
                      
                      <a href="https://www.linkedin.com/in/dhruv-patel-8a5a74222"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/invites/contact/?i=1e7mr2v5haze0&utm_content=3nw4boc"><FaInstagram /></a>
                    </div>
                  </div>
                  <div className={styles.textMobile}>
                    <div className={styles.titleMobile}>
                      <p>Dhruv Patel</p>
                      <span>SARC Design Co-ordinator 2022-23</span>
                    </div>
                    <div className={styles.socialMobile}>
                      
                      <a href="https://www.linkedin.com/in/dhruv-patel-8a5a74222"><FaLinkedinIn /></a>
                      <a href="https://www.instagram.com/invites/contact/?i=1e7mr2v5haze0&utm_content=3nw4boc"><FaInstagram /></a>
                    </div>
                  </div>
                </div> */}
              {/* </div> */}
            {/* </div> */}
          {/* </div> */}
        {/* </div> */}

    <div className={styles.line2}> 
          <div className={styles.contactus}>For any issues, contact:</div> <br></br>
    
    Indrani Sahu, Web CTM | SARC 2026-27  (9302041423)<br /><br></br>
    {/* Arush Srivastav, Web CTM | SARC 2025-26  (9005549919)<br /><br></br>
    Khushi Yadav, Web CTM | SARC 2025-26  (8930097733)<br /><br></br> */}
    {/* Ashwani Dubey, Web CTM | SARC 2024-25  (6263173987)<br /><br></br> */}
    
    </div>
      </div >
   
    <Footers />
  
</>
    )
}

export default Devteam